import React from "react";
import { Link } from "react-router-dom";
import { imageBasePath } from "../../Utils/config";

const ServiceLabel = (props) => {
  const { label, imgPath, style, toPath } = props;
  return (
    <Link to={toPath || ""} className="flex justify-center items-center">
      <div className="grid grid-cols-3 items-center w-[193px] h-[88px] rounded-2xl border border-solid border-[#D9D9D9] px-2">
        <div className="flex justify-center items-center">
          <img
            src={imageBasePath + imgPath}
            alt={"ServiceLabel Icon"}
            style={{ ...style }}
            {...props}
          />
        </div>
        <p className="font-font-Titillium text-sm font-semibold tracking-wide uppercase col-span-2">
          {label}
        </p>
      </div>
    </Link>
  );
};

export default ServiceLabel;
